import { TranslateService } from '@ngx-translate/core';
import { de_DE, en_US, es_ES, fr_FR, it_IT, pt_PT } from 'ng-zorro-antd/i18n';

export function i18nAntFactory(translate: TranslateService) {
  switch (translate.currentLang as string) {
  case 'en':
    return en_US;
  case 'de':
    return de_DE;
  case 'fr':
    return fr_FR;
  case 'es':
    return es_ES;
  case 'it':
    return it_IT;
  case 'pt':
    return pt_PT;
  default:
    return en_US;
  }
}
